export var oneDayTime = 24 * 60 * 60 * 1000;
export function isValidDate(date) {
  return date instanceof Date && !isNaN(date.getTime());
}
export function getDateToString(date) {
  return date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate();
}
export function formatData(data) {
  if (data === void 0) {
    data = [];
  }
  var result = {};
  data.forEach(item => {
    if (item.date && isValidDate(new Date(item.date))) {
      item.date = getDateToString(new Date(item.date));
      result[item.date] = item;
    }
  });
  return result;
}

/** 排序 比较函数 */
export function numberSort(keys) {
  if (keys === void 0) {
    keys = [];
  }
  return keys.sort((x, y) => {
    if (x < y) return -1;else if (x > y) return 1;
    return 0;
  });
}
export function existColor(num, nums, panelColors) {
  if (num === void 0) {
    num = 0;
  }
  if (panelColors === void 0) {
    panelColors = {};
  }
  var color = '';
  for (var a = 0; a < nums.length; a += 1) {
    if (nums[a] > num) {
      color = panelColors[nums[a]];
      break;
    }
    color = panelColors[nums[a]];
  }
  return color;
}